import { __assign, __rest } from "tslib";
import createToolbar from './toolbar';
import { createBasePlugin, PLUGIN_DECORATION_PROPS, PLUGIN_DECORATIONS, } from 'wix-rich-content-editor-common';
import BadPlugin from '../../components/BadPlugin';
import { IMAGE_TYPE, IMAGE_TYPE_LEGACY, getDefaultComponentData, } from './types';
import imageComponentWrapper from './components/ImageComponentWrapper/image-component-wrapper';
function imagePluginCreator(pluginConfig) {
    return function (config) {
        if (config === void 0) { config = {}; }
        var decorator = config.decorator, helpers = config.helpers, t = config.t, theme = config.theme, isMobile = config.isMobile, anchorTarget = config.anchorTarget, relValue = config.relValue, image = config.image, rest = __rest(config, ["decorator", "helpers", "t", "theme", "isMobile", "anchorTarget", "relValue", "image"]);
        return createBasePlugin(__assign({ component: pluginConfig.component
                ? imageComponentWrapper(pluginConfig.component)
                : BadPlugin, pluginDecorationProps: function (props, componentData) {
                var _a, _b, _c;
                if (!((_a = helpers === null || helpers === void 0 ? void 0 : helpers.featureFlags) === null || _a === void 0 ? void 0 : _a.editor_experimental) ||
                    !pluginConfig.allowResize) {
                    return {};
                }
                var size = (_b = componentData.config) === null || _b === void 0 ? void 0 : _b.size;
                var calulatedProps = props;
                if (size === 'original' && ((_c = componentData.src) === null || _c === void 0 ? void 0 : _c.width)) {
                    calulatedProps = __assign(__assign({}, props), { width: componentData.src.width, style: __assign(__assign({}, (componentData.src.style || {})), { width: componentData.src.width }) });
                }
                var resizeableProps = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](calulatedProps);
                if (size === 'inline') {
                    return resizeableProps;
                }
                else if (size === 'original') {
                    return __assign(__assign({}, resizeableProps), { style: __assign(__assign({}, resizeableProps.style), { maxWidth: '100%' }) });
                }
                else {
                    var _d = resizeableProps.style, width = _d.width, allButWidth = __rest(_d, ["width"]); // eslint-disable-line no-unused-vars
                    return __assign(__assign({}, resizeableProps), { style: __assign({}, allButWidth) });
                }
            }, componentWillReceiveDecorationProps: function (props, nextProps, onPropsChange) {
                var width = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](props).width;
                var nextWidth = PLUGIN_DECORATION_PROPS[PLUGIN_DECORATIONS.RESIZEABLE](nextProps).width;
                if (width !== nextWidth) {
                    onPropsChange({ size: 'inline', width: nextWidth });
                }
            }, decorator: decorator, settings: __assign(__assign({}, pluginConfig), image), theme: theme, type: IMAGE_TYPE, legacyType: IMAGE_TYPE_LEGACY, toolbar: createToolbar({
                helpers: helpers,
                anchorTarget: anchorTarget,
                relValue: relValue,
                t: t,
                pluginConfig: pluginConfig,
            }), helpers: helpers,
            isMobile: isMobile,
            anchorTarget: anchorTarget,
            relValue: relValue,
            t: t, defaultPluginData: getDefaultComponentData() }, rest), {});
    };
}
export { imagePluginCreator };
//# sourceMappingURL=createImagePlugin.js.map